"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGeneratePath = exports.mockParseGoal = void 0;
exports.mockParseGoal = {
    success: true,
    tags: {
        languageTags: ['java'],
        vulnerabilityTags: ['sql-injection'],
        roleTags: ['backend'],
    },
    unavailableAxes: [],
};
exports.mockGeneratePath = {
    success: true,
    pathUuid: 'a1b2c3d4-mock-path-uuid',
    lessons: [
        {
            uuid: 'mock-lesson-1',
            displayName: 'SQL Injection',
            duration: '5-8',
            iconUrl: null,
            hasChallenge: true,
            isCustom: false,
            systemCourse: 'OWASP Top 10',
            customCourses: [],
            sequencePosition: 1,
            justification: 'Introduces SQL injection fundamentals so Java backend developers understand how crafted input can manipulate SQL queries.',
        },
        {
            uuid: 'mock-lesson-2',
            displayName: 'Command Injection',
            duration: '5-8',
            iconUrl: null,
            hasChallenge: false,
            isCustom: false,
            systemCourse: 'OWASP Top 10',
            customCourses: [],
            sequencePosition: 2,
            justification: 'Covers a related injection pattern backend engineers should recognize in the same review pass.',
        },
    ],
};
